// @ts-check
import React, { useRef, useState } from "react"
import { useSession } from "../../hooks/auth/useSession.hook"
import { OverlayPanel } from "primereact/overlaypanel"
import AppMenuUserPreview from "../../routers/controllers/AppMenuUserPreview"
import { useNavigate } from "react-router-dom"
import useSidebarContext from "../../hooks/contextConsumers/useSidebarContext.hook"
import ModalForm from "./modalForm/ModalForm.compunds"

function UserMenu() {
  const { setSidebarActive } = useSidebarContext()
  const [confirmLogoutVisible, setConfirmLogoutVisible] = useState(false)
  const navigate = useNavigate()
  const handleConfirmLogout = async () => {
    setSidebarActive(false)
    navigate("/logout")
  }

  const { user } = useSession()
  const avatarRef = useRef(null)

  return (
    <div className="user-name-tag">
      <span
        className="user-tag user-tag-mobile-nav border-circle text-blue-600 flex align-items-center justify-content-center font-bold my-auto"
        style={{
          backgroundColor: "var(--surface-highlight__light)",
        }}
        ref={avatarRef}
        onClick={(e) =>
          // @ts-ignore
          avatarRef.current?.toggle(e)
        }
      >
        {user?.nameTag}
      </span>
      <OverlayPanel className="user-info-top-bar-responsive" ref={avatarRef}>
        <AppMenuUserPreview
          closeMobileOverlay={() => {
            // @ts-ignore
            avatarRef.current?.hide()
          }}
          showLogoutModal={() => setConfirmLogoutVisible(true)}
        />
      </OverlayPanel>
      <ModalForm
        visible={confirmLogoutVisible}
        setVisible={setConfirmLogoutVisible}
        header={
          <div className="flex gap-3 align-items-center">
            <i
              className="pi pi-exclamation-circle text-4xl"
              style={{ color: "var(--clr-info__dark)" }}
            />
            <span className="text-3xl font-semibold font-cairo">
              Cierre de sesión
            </span>
          </div>
        }
        saveLabel="Cerrar"
        closable={false}
        service={handleConfirmLogout}
      >
        ¿Estás seguro que deseas cerrar sesión?
      </ModalForm>
    </div>
  )
}

export default UserMenu
